import { FormValidationRules } from "@components/Form";
import { FormField, FormFieldProps } from "@components/Form/Field";
import {
  FormInputSelect,
  FormInputSelectProps,
} from "@components/Inputs/Select";
import { useCorban } from "@hooks/useCorban";
import { CorbanOption } from "@hooks/useCorbansOptions";

export type FieldCorbansProps = FormFieldProps & {
  selectProps?: FormInputSelectProps<CorbanOption["id"], CorbanOption>;
};

export const FieldCorbans = ({ selectProps, ...props }: FieldCorbansProps) => {
  const { corbans: options, loading } = useCorban();

  return (
    <FormField
      wrapperCol={{ xs: 24 }}
      rules={[FormValidationRules.required("Selecione o Corban")]}
      {...props}
    >
      <FormInputSelect
        options={selectProps?.options ?? options}
        loading={loading}
        fieldNames={{ label: "name", value: "id" }}
        showSearch
        placeholder="Selecionar..."
        {...selectProps}
      />
    </FormField>
  );
};
